import * as React from "react";
import { BaseComponent } from "../../../../../react-core/Html/BaseComponent";
import { RadiosEditor } from "../../../../../react-core/Html/RadiosEditor";
import { PortfolioViewMenuAdditionalInfo } from "../../../../../Wrap/Models/Domains/Menu/PortfolioViewMenuAdditionalInfo";
import { isConsolidate } from "../../Clients/PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { ConsolidatedAccountStore } from "../../Clients/PortfolioDashboard/Store/Variable";

interface IPortfolioViewActionMenuOverlayProps {
    additionalInfo: PortfolioViewMenuAdditionalInfo;
    selectedHeadAccount: string;
    onChangeHeadAccount: (hierarchyId: string) => void;
}

interface IPortfolioViewActionMenuOverlayState {}

export class PortfolioViewActionMenuOverlay extends BaseComponent<
    IPortfolioViewActionMenuOverlayProps,
    IPortfolioViewActionMenuOverlayState
> {
    constructor(props: IPortfolioViewActionMenuOverlayProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { additionalInfo } = this.props;
        const options = additionalInfo.UnderlyingClientAccount;
        return (
            <>
                <h2 style={{ color: "#fff" }}>Select a head account to view</h2>
                <RadiosEditor
                    cssWrapper={"radio-group rg-inline mt-40 is-radio-pin-inverse"}
                    options={options.map((ele) => ele.HierarchyId)}
                    getText={(option) => {
                        const account = options.find((ele) => ele.HierarchyId == option);
                        return account.AccountName + " - " + account.HeadClAccountId;
                    }}
                    onChange={(value) => {
                        if (value !== this.props.selectedHeadAccount) {
                            this.props.onChangeHeadAccount(value);
                        }
                    }}
                    selected={this.props.selectedHeadAccount}
                />
                <hr />
            </>
        );
    }
}
